import React, { Component } from 'react';
import classNames from 'classnames';

class Tabs extends Component {

  constructor( props ) {
    super( props );
    this.state = {
      selected: 0
    }
  }

  handleClick = ( child, e, i ) => {
    e.preventDefault();
    this.setState( {
      selected: i
    } );
    child.props.handleClick();
  };

  render() {
    return (
      <div className="Tabs">
        <ul className={classNames('TabsLabels', this.props.horizontal && 'TabsLabels--horizontal')}>
          {this.props.children.map( ( child, i ) => (
            <li key={i} className={(child.props.subLabel ? 'hasSubLabel' : '')}>
              <button
                type="button"
                className={classNames('linkStyle', {'active': this.state.selected === i})}
                onClick={( e ) => {
                  this.handleClick( child, e, i );
                }}>
                {child.props.label}
              </button>
            </li>
          ) )}
        </ul>
        {this.props.children[ this.state.selected ]}
      </div>
    )
  }
}

export default Tabs;